// extracted by mini-css-extract-plugin
export default {"mCard":"Zs-z","image":"_s-z","imageNoBackground":"at-z","fullWidth":"bt-z"};